module.exports = __webpack_public_path__ + "static/card-img-9-b2405f0d3ae4a019deedfedd66ee2256.jpg";